import { render, staticRenderFns } from "./scraping_xpath.vue?vue&type=template&id=71fec426&scoped=true"
import script from "./scraping_xpath.vue?vue&type=script&lang=js"
export * from "./scraping_xpath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fec426",
  null
  
)

export default component.exports